import styled from "@emotion/styled"
import { Link } from "gatsby"
import { darken, readableColor } from "polished"

import { rhythm, scale } from "@utils/typography"

const Button = styled.button`
  background: ${props =>
    props.background ? props.background : props.theme.colours.primary};
  border: none;
  color: ${props =>
    readableColor(
      props.background ? props.background : props.theme.colours.primary
    )};
  transition: background-color 200ms linear;

  &:hover,
  &:focus {
    background: ${props =>
      darken(
        0.05,
        props.background ? props.background : props.theme.colours.primary
      )};
    color: ${props =>
      readableColor(
        darken(
          0.05,
          props.background ? props.background : props.theme.colours.primary
        )
      )};
  }
`

const ButtonUnstyled = styled.button`
  background: none;
  border: none;
  color: ${props =>
    props.background ? props.background : props.theme.primary};

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`

const ToTopButton = styled(Button)`
  opacity: ${props => (props.visible ? "1.0" : "0")};
  position: fixed;
  bottom: ${rhythm(1 / 4)};
  right: ${rhythm(1 / 4)};
  transition: opacity 200ms linear;
  z-index: 99;

  @media (prefers-reduced-motion) {
    transition: none;
  }
`

const ViewButton = styled(Link)`
  color: ${props => props.colour || props.theme.color};
  ${scale(1 / 5)};
  padding-bottom: ${rhythm(1 / 4)};
  position: relative;
  text-decoration: none;

  &:before {
    bottom: 0;
    content: "";
    border-bottom: 2px solid currentColor;
    display: block;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    transition: width 100ms ease;
    width: 100%;
  }

  @media (prefers-reduced-motion: reduce) {
    &:before {
      transition: none;
    }
  }

  &:after {
    border-bottom: 2px solid currentColor;
    border-right: 2px solid currentColor;
    content: "";
    display: inline-block;
    height: 12px;
    margin-left: ${rhythm(1 / 2)};
    transform: rotate(-45deg);
    width: 12px;
  }

  &:hover,
  &:focus {
    text-decoration: none;

    &:before {
      width: 50%;
    }
  }
`

export { Button, ButtonUnstyled, ViewButton, ToTopButton }
